import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function HelpTip({ children }) {
    return (
        <TooltipProvider delayDuration={100}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button type="button" className="text-neutral-400 hover:text-black inline-flex" aria-label="Help">
                        <Info className="w-3.5 h-3.5" />
                    </button>
                </TooltipTrigger>
                <TooltipContent side="right" className="max-w-xs bg-black text-white border-2 border-black font-mono text-xs">
                    {children}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
